import { path, pathOr } from 'ramda';

import { Text } from '@frontend/legacy-components';

import type { Notification } from 'modules/notifications/types';

export type NotificationMessageProps = { notification: Notification };

const NotificationMessage = ({ notification }: NotificationMessageProps) => {
  let title = pathOr(false, ['title'], notification)
    ? `${path(['title'], notification)}: `
    : '';

  const msg = pathOr(false, ['body'], notification)
    ? `${path(['body'], notification)}`
    : '';

  if (!msg) title = title.slice(0, -2);

  return (
    <Text as="span" fontWeight="heavy">
      {title}{' '}
      <Text as="span" fontWeight="default">
        {msg}
      </Text>
    </Text>
  );
};

export default NotificationMessage;
